var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dash',{attrs:{"icon":"fa fa-comment","titulo":_vm.titulo,"mostrarQtd":false,"loading":_vm.loading},nativeOn:{"click":function($event){return _vm.$router.push({
            name: 'Pesquisas_Responder',
            params: {
                pesquisaId: _vm.tipo
            }
        })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }